module.exports = __webpack_public_path__ + "img/2_98.1805f53c.png";